
export const labels = {
    obrigatorio:'Campo obrigatório',
    minimo:'Este campo requer o minimo de 3 caracteres',
    maximo: 'Este campo tem o limite de 256 caracteres',
    paid: { 'yes':'Pago', 'no':'Em aberto'}
}
